import { LogoMark } from "./LogoMark";

export const Logo = ({ tone = "dark" }) => {
  const text = tone === "dark" ? "text-pine" : "text-cream";
  const sub = tone === "dark" ? "text-sage" : "text-cream/60";
  return (
    <span className="flex items-center gap-3">
      <LogoMark className="h-9 w-9 shrink-0" />
      <span className="flex flex-col leading-none">
        <span className={`font-serif font-semibold text-xl tracking-[0.14em] ${text}`}>
          ADVESHTA
        </span>
        <span className={`font-mono text-[9px] tracking-[0.42em] mt-1.5 ${sub}`}>
          MILK · ORGANIC
        </span>
      </span>
    </span>
  );
};
